export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6587.cae8552e.jpg";